<template>
  <div class="wrapper">
    <parallax
      :style="headerStyle"
      class="section page-header header-filter"
    ></parallax>
    <div class="main main-raised-top">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-60 mx-auto">
              <div class="profile">
                <h4 class="title"></h4>
              </div>

              <div class="BaiDuMap">
                <baidu-map
                  :center="center"
                  :scroll-wheel-zoom="true"
                  :zoom="zoom"
                  style="width: 90%; height: 65%"
                >
                  <bm-marker
                    :dragging="false"
                    :position="center"
                    animation="BMAP_ANIMATION_BOUNCE"
                  >
                  </bm-marker>

                  <!-- 必须给容器指高度，不然地图将显示在一个高度为0的容器中，看不到 -->
                  <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                  <bm-geolocation
                    :autoLocation="true"
                    :showAddressBar="false"
                    anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                  ></bm-geolocation>
                  <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
                </baidu-map>
              </div>
            </div>

            <div class="md-layout-item md-size-40 mx-auto">
              <div class="profile">
                <h4 class="title"></h4>
              </div>
              <div class="profile">
                <h3 class="title ">常州华龙通信科技股份有限公司</h3>
              </div>

              <md-divider></md-divider>

              <md-list class="md-double-line">
                <md-list-item>
                  <md-icon class="md-primary">place</md-icon>

                  <div class="md-list-item-text">
                    <span>江苏省常州市钟楼区</span>
                    <span>中吴大道1809号金翌大厦5层</span>
                  </div>
                </md-list-item>

                <md-divider></md-divider>

                <md-list-item>
                  <md-icon class="md-primary">phone</md-icon>
                  <div class="md-list-item-text">
                    <span>17327912973</span>
                    <span>商务电话</span>
                  </div>
                </md-list-item>

                <md-list-item>
                  <md-icon class="md-primary">phone_iphone</md-icon>
                  <div class="md-list-item-text">
                    <span>17712758002</span>
                    <span>孙经理</span>
                  </div>
                </md-list-item>

                <md-divider></md-divider>
                <md-list-item>
                  <md-icon class="md-primary">email</md-icon>
                  <div class="md-list-item-text">
                    <span>st@hualong-tech.com</span>
                    <span></span>
                  </div>
                </md-list-item>

                <md-divider></md-divider>
              </md-list>

              <div class="profile">
                <h2 class="title"></h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  bodyClass: "profile-page",

  data() {
    return {
      // 地址信息
      address: null,
      center: { lng: 119.919493, lat: 31.763871 },
      //地图展示级别
      zoom: 17
    };
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/contact.jpg")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}
</style>

<style scoped>
.BaiDuMap {
  width: 100%;
  height: 100%;
}
</style>
